import React, { Component } from 'react';
import { Link } from 'react-router-dom';

let image_path = "/images/art/";
let image = "implicate_order.jpg"
import essayInfo from '../essays/EssayInfo.js'

let formatDate = function(date){
  let year = date.substring(0,4);
  let month = date.substring(4,6);
  let day = date.substring(6,date.length);
  return month+"-"+day+"-"+year;
}

class Essays extends Component {
  render() {
    return (
        <div id="essays" className="page page5"> 
            <div className="essays-top-section" >
                <h1>Essays</h1>
                <h3>Research papers on</h3>
                <ul>
                  <li>Theories of Creativity </li>
                  <li>Environmentalism</li>
                  <li>Mythoology</li>
                  <li>Spirituality</li>
                  <li>Permaculture</li>
                </ul>
            </div>
            <div className="essays-bottom-section">
                <h2>Links</h2>
                <div className="essays-link-section">
                  {essayInfo.slice(0,6).map((essay, index) => 
                    <div className="essay-link" key={index}>
                        <a href={essay.url} key={index}>{essay.title}</a>
                        <small className="date"><i>&nbsp;—&nbsp;{formatDate(essay.date)}</i></small>
                    </div>
                  )}
                </div>
                
            </div>
        </div>
    );
  }
}

export default Essays;
